module.exports = __webpack_public_path__ + "img/beer_id-71.10f7ab37.png";